import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import clsx from "clsx";
import _ from "lodash";
import { Search } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logodark.png";
import profileImage from "../../assets/profile.png";
import { useLayoutStore } from "../../context";
import constants from "../../utils/constants";
import { Divider } from "../UI/divider";

export default function TopNav() {
  const DIVIDER = "DIVIDER";
  const { isSideNavOpen, setSideNavOpen } = useLayoutStore();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownItems = [
    { label: "Account", path: "/" },
    { label: "Settings", path: "/" },
    { label: "FAQ", path: "/" },
    { label: DIVIDER },
    { label: "Logout", path: "/" },
  ];

  const svgColor = "#ffbb10"; // marigold
  const paths = constants.ROUTE_PATHS;
  const pageTitles = constants.PAGE_TITLES;
  const currentPath = location.pathname;
  let pageTitle = pageTitles[currentPath] || "Unknown Page";
  let mainSection = null;

  if (
    currentPath.startsWith(paths.SELF_ASSESSMENT) &&
    currentPath !== paths.SELF_ASSESSMENT
  ) {
    mainSection = pageTitles[paths.SELF_ASSESSMENT];
  }
  if (
    currentPath.startsWith(paths.VOLUNTEER_ENGAGEMENT) &&
    currentPath !== paths.VOLUNTEER_ENGAGEMENT
  ) {
    mainSection = pageTitles[paths.VOLUNTEER_ENGAGEMENT];
  }

  const formattedTitle = mainSection
    ? `${mainSection}: ${pageTitle}`
    : pageTitle;

  const currentPageTitleLeftMargin = isSideNavOpen ? "ml-[9rem]" : "ml-6";

  return (
    <div className="flex w-screen h-16 items-center justify-between bg-emerald px-4 fixed top-0 z-50">
      <div className="flex flex-1 items-center">
        <div className="mr-2 lg:mr-6 flex items-center space-x-4 cursor-pointer">
          {isSideNavOpen ? (
            <svg
              width="2rem"
              height="2rem"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setSideNavOpen(false)}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4ZM4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H4ZM13 18C13 17.4477 13.4477 17 14 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H14C13.4477 19 13 18.5523 13 18Z"
                fill={svgColor}
              />
            </svg>
          ) : (
            <svg
              width="2rem"
              height="2rem"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setSideNavOpen(true)}
            >
              <path
                d="M4 18H10"
                stroke={svgColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M4 12L20 12"
                stroke={svgColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M4 6L20 6"
                stroke={svgColor}
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>

        {/* Logo */}
        <img
          src={logo}
          alt="logo"
          className="h-12 cursor-pointer"
          onClick={() => navigate(paths.DASHBOARD)}
        />

        {/* Current Page Title */}
        <h1
          className={clsx(
            currentPageTitleLeftMargin,
            "text-xl font-semibold text-marigold transition-all duration-500 ease-in-out text-nowrap"
          )}
        >
          {formattedTitle}
        </h1>
      </div>

      {/* Search Bar */}
      <div className="flex flex-1 justify-end mr-6">
        <div className="relative w-64">
          <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search..."
            className="pl-10 pr-4 py-2 w-full rounded-lg bg-cream text-gray-900 focus:ring-2 focus:ring-marigold focus:outline-none"
          />
        </div>
      </div>

      <div className="flex flex-row pr-2">
        <Menu as="div" className="relative">
          <MenuButton className="flex rounded-full cursor-pointer items-center">
            <img
              src={profileImage}
              alt="avatar"
              className="h-10 w-10 rounded-full"
            />
          </MenuButton>
          <MenuItems className="absolute right-0 z-50 w-48 origin-top-right rounded-md bg-cream py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {_.map(dropdownItems, (item, idx) => {
              if (item.label === DIVIDER)
                return (
                  <MenuItem key={"divider-" + idx}>
                    <Divider />
                  </MenuItem>
                );
              return (
                <MenuItem key={item.label} className="z-50">
                  <div
                    className={`block px-4 py-2 text-sm text-gray-700 hover:cursor-pointer`}
                    onClick={() => {
                      if (item && item.path) {
                        navigate(item.path);
                      }
                    }}
                  >
                    {item.label}
                  </div>
                </MenuItem>
              );
            })}
          </MenuItems>
        </Menu>
      </div>
    </div>
  );
}
